module.exports = __webpack_public_path__ + "img/icon1-4.002e7582.png";